import React, { useEffect, useState } from "react";
import { fetchUserDetails, getAllUsers } from "../../api/api";
import "./Departments.css";
import catPhoto from "../../images/cat-photo.png";
import Preloader from "../Preloader/Preloader";
import UserPopup from "./UserPopup";

const Departments = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [departmentUsersMap, setDepartmentUsersMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserGroup, setSelectedUserGroup] = useState(null);
  const [selectedUserRole, setSelectedUserRole] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const userData = await fetchUserDetails();
        setCurrentUser(userData);
        const allUsers = await getAllUsers();

        const usersByDepartment = {};

        // Получаем все группы из всех департаментов
        const allGroups = userData.departments.flatMap(
          (dept) => dept.groups || []
        );
        allGroups.forEach((userGroup) => {
          const usersInDepartment = allUsers.filter(
            (user) =>
              user.groups.some((group) => group.id === userGroup.id) &&
              user.is_active &&
              !user.access_levels.some((level) => level.name === "РО")
          );

          usersByDepartment[userGroup.id] = {
            departmentName: userGroup.name,
            users: usersInDepartment,
          };
        });

        setDepartmentUsersMap(usersByDepartment);
      } catch (err) {
        setError("Ошибка при загрузке данных отдела");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handleUserClick = (user, groupName, role) => {
    setSelectedUser(user);
    setSelectedUserGroup(groupName);
    setSelectedUserRole(role);
  };

  const handleClosePopup = () => {
    setSelectedUser(null);
    setSelectedUserGroup(null);
    setSelectedUserRole(null);
  };

  if (loading) return <Preloader />;
  if (error) return <div>{error}</div>;

  return (
    <div className="departmentContainer">
      <h2 className="departments_title">Мои отделы</h2>
      {Object.entries(departmentUsersMap).map(
        ([groupId, { departmentName, users }]) => (
          <div key={groupId}>
            <h3>{departmentName}</h3>
            <div className="usersGrid">
              {users.map((user) => {
                const userRole =
                  user.groups.find((group) => group.id === parseInt(groupId))
                    ?.roles[0]?.name || "Должность не указана";

                return (
                  <div
                    key={user.id}
                    className="userCard"
                    onClick={() =>
                      handleUserClick(user, departmentName, userRole)
                    }
                  >
                    <div className="imageContainer">
                      <img
                        src={catPhoto}
                        alt={`${user.name} ${user.surname}`}
                        className="userImage"
                      />
                    </div>
                    <div className="userInfo">
                      <p className="userPosition">{userRole}</p>
                      <p className="userName">{`${user.surname} ${user.name}`}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )
      )}
      {selectedUser && (
        <UserPopup
          user={selectedUser}
          groupName={selectedUserGroup}
          role={selectedUserRole}
          onClose={handleClosePopup}
        />
      )}
    </div>
  );
};

export default Departments;
